import ScrollReveal from '@/components/ScrollReveal';

const stats = [
  { number: '$2.4B+', label: 'Bonds Structured' },
  { number: '85+', label: 'Transactions Closed' },
  { number: '12+', label: 'Countries Served' },
  { number: '6', label: 'Bond Types Offered' },
];

export default function Hero() {
  const scrollTo = (e, href) => {
    e.preventDefault();
    document.querySelector(href)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center"
      style={{
        backgroundColor: '#060f1d',
        backgroundImage: 'linear-gradient(to right, rgba(255,255,255,0.03) 1px, transparent 1px), linear-gradient(to bottom, rgba(255,255,255,0.03) 1px, transparent 1px)',
        backgroundSize: '40px 40px',
        paddingTop: '6rem',
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 w-full py-16 lg:py-24">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left */}
          <div>
            <ScrollReveal>
              <div
                className="inline-flex items-center gap-2 rounded-full px-4 py-1.5 mb-8"
                style={{ backgroundColor: 'rgba(201,168,76,0.12)', border: '1px solid rgba(201,168,76,0.25)' }}
                data-testid="hero-badge"
              >
                <span className="w-2 h-2 rounded-full" style={{ backgroundColor: '#2d8a56' }} />
                <span className="text-sm font-inter" style={{ color: '#dfc26e' }}>Authorized & Regulated</span>
              </div>
            </ScrollReveal>

            <ScrollReveal delay={100}>
              <h1 className="font-playfair font-bold text-4xl sm:text-5xl lg:text-6xl leading-tight mb-6">
                <span className="text-white">Precision Bond Structuring</span>
                <br />
                <span style={{ color: '#c9a84c' }}>for the New Economy</span>
              </h1>
            </ScrollReveal>

            <ScrollReveal delay={200}>
              <p className="font-inter text-base sm:text-lg leading-relaxed mb-8 max-w-xl" style={{ color: '#9ca3af' }}>
                ALC Bond is a premier debt capital markets arranger operating from DIFC and ADGM. We structure conventional bonds, sukuk, green bonds, and innovative financing instruments for corporates, institutions, and sovereign entities across the GCC, MENA, and global markets.
              </p>
            </ScrollReveal>

            <ScrollReveal delay={300}>
              <div className="flex flex-wrap gap-4">
                <a
                  href="#contact"
                  onClick={(e) => scrollTo(e, '#contact')}
                  className="font-semibold px-6 py-3 rounded"
                  style={{ backgroundColor: '#c9a84c', color: '#060f1d', transition: 'background-color 200ms' }}
                  onMouseEnter={(e) => e.target.style.backgroundColor = '#dfc26e'}
                  onMouseLeave={(e) => e.target.style.backgroundColor = '#c9a84c'}
                  data-testid="hero-cta-proposal"
                >
                  Request Proposal
                </a>
                <a
                  href="#services"
                  onClick={(e) => scrollTo(e, '#services')}
                  className="font-semibold px-6 py-3 rounded text-white"
                  style={{ border: '1px solid rgba(255,255,255,0.3)', transition: 'background-color 200ms' }}
                  onMouseEnter={(e) => e.target.style.backgroundColor = 'rgba(255,255,255,0.05)'}
                  onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                  data-testid="hero-cta-services"
                >
                  Explore Services
                </a>
              </div>
            </ScrollReveal>
          </div>

          {/* Right - Stat Cards */}
          <div className="grid grid-cols-2 gap-4">
            {stats.map((stat, i) => (
              <ScrollReveal key={stat.label} delay={200 + i * 100}>
                <div
                  className="p-6 rounded-xl backdrop-blur-sm"
                  style={{
                    backgroundColor: 'rgba(15, 34, 64, 0.6)',
                    border: '1px solid rgba(255,255,255,0.1)',
                  }}
                  data-testid={`hero-stat-${i}`}
                >
                  <div className="font-playfair font-bold text-2xl sm:text-3xl mb-1" style={{ color: '#c9a84c' }}>
                    {stat.number}
                  </div>
                  <div className="text-sm font-inter" style={{ color: '#9ca3af' }}>
                    {stat.label}
                  </div>
                </div>
              </ScrollReveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
